<template>
  <div
    class="tw-relative tw-block md:tw-hidden"
    v-if="$route.name === 'donor-my-contact-list' || $route.name === 'donor-my-team-contact-list'"
  >
    {{ $route.name }}
    <div
      class="clip-bottom-round tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-[70vh] tw-bg-[var(--my-primary)] tw-z-[1]"
    ></div>
  </div>
</template>

<script>
export default {
  name: "my-top-curved-bg",
};
</script>

<style lang="scss" scoped>
.clip-bottom-round {
  clip-path: ellipse(170% 100% at 50% 0%);
}
</style>
